import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a086223"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_project" }
const _hoisted_2 = { class: "list_search" }
const _hoisted_3 = { class: "search_header" }
const _hoisted_4 = {
  class: "flexWrap",
  style: {"width":"80%"}
}
const _hoisted_5 = { class: "header_nr flexAlign" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"82px"}
}, "部门：", -1))
const _hoisted_7 = { class: "header_nr flexAlign" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"82px"}
}, "开始时间：", -1))
const _hoisted_9 = { class: "header_nr flexAlign" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"82px"}
}, "截止时间：", -1))
const _hoisted_11 = { class: "header_nr flexAlign" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"82px"}
}, "任务类型：", -1))
const _hoisted_13 = { class: "header_nr flexAlign" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"82px"}
}, "事项类型：", -1))
const _hoisted_15 = { class: "header_nr flexAlign" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"82px"}
}, "空闲用户：", -1))
const _hoisted_17 = {
  class: "header_twonr",
  style: {"margin-top":"20px"}
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("导出excel")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("导出明细excel")
const _hoisted_21 = { class: "d" }
const _hoisted_22 = { class: "d" }
const _hoisted_23 = { class: "d" }
const _hoisted_24 = { class: "d" }
const _hoisted_25 = { class: "d" }
const _hoisted_26 = { class: "d" }
const _hoisted_27 = { class: "d" }
const _hoisted_28 = { class: "d" }
const _hoisted_29 = { class: "my-header" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "添加", -1))
const _hoisted_31 = { class: "my-header" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Excel导入", -1))
const _hoisted_33 = { class: "my-header" }
const _hoisted_34 = {
  class: "flexAlign",
  style: {"justify-content":"flex-end","margin-top":"12px"}
}
const _hoisted_35 = { class: "my-header" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "任务详情", -1))

import { CirclePlus,Search,Close } from '@element-plus/icons-vue';
	import { reactive,ref,onMounted,nextTick,computed } from 'vue';
	import AddUser from '@/components/AddUser.vue';
	import TaskDetails from '@/components/TaskDetails.vue';
	import { requestYuqiUserList,requestYuqiTaskUserList,requestDDDepartTree } from '@/api/xmApi';
	import { requestGetAllConfig } from '@/api/configApi.js';
	import { ElMessage } from 'element-plus';
	import Excel from '@/components/Excel';
	
export default /*#__PURE__*/_defineComponent({
  name: 'tjyuqiuser',
  setup(__props) {

	const loading = ref(false)
	const tableData = ref([])
	const pageIndex = ref(1)
	const pageSize = ref(10)
	const pages = ref({
		totalCount:0
	})
	const search = ref({
		startdate1:'',
		startdate2:'',
		tasktype:'',
		sxlx:'',
		idle:''
	})//搜索
	const sxlxLists = ref<any[]>([])
	const DDDepartlist= ref([])
	const addShow = ref(false)
	const userShow = ref(false)
	const exceladdShow = ref<boolean>(false)
	const excelShow= ref<boolean>(false)
	const uuid = ref("")
	const dddepartid=ref("")
	onMounted(()=>{
		getUserList();
		getDDDepartlist();
		getSxlxList();
	})
	const getSxlxList = () => {
		requestGetAllConfig({type:'事项类型'}).then((res:any)=>{
			if(res.status === 1){
				sxlxLists.value = res.datalist
			}
		})
	}
	// ===== 部门树下拉（选择上级时统计包含其所有下级部门人员）=====
	const deptTreeData = ref<any[]>([])
	const deptTreeProps = {
		value: 'dept_id',
		label: 'name',
		children: 'children'
	}
	// 将后端返回的扁平部门列表（含 parent_id）构建为树
	const buildDeptTree = (list: any[]): any[] => {
		const map: any = {}
		const tree: any[] = []
		list.forEach((item: any) => {
			map[String(item.dept_id)] = { ...item, children: [] }
		})
		list.forEach((item: any) => {
			const node = map[String(item.dept_id)]
			const pid = String(item.parent_id || '')
			// 无父节点、父节点不存在、或父节点为自身时，作为根节点
			if (pid && pid !== '0' && map[pid] && pid !== String(item.dept_id)) {
				map[pid].children.push(node)
			} else {
				tree.push(node)
			}
		})
		// 清理空的 children，避免叶子节点显示多余展开箭头
		const clean = (nodes: any[]) => {
			nodes.forEach((n: any) => {
				if (!n.children || n.children.length === 0) {
					delete n.children
				} else {
					clean(n.children)
				}
			})
		}
		clean(tree)
		return tree
	}
	const getDDDepartlist = () =>{
		requestDDDepartTree({}).then((res:any)=>{
			if(res.status === 1){
				deptTreeData.value = buildDeptTree(res.datalist || [])
			} else {
				deptTreeData.value = []
			}
		}).catch(()=>{
			deptTreeData.value = []
		})
	}
	// 切换部门后重新查询（后端会按"部门+所有下级"统计）
	const onDeptChange = () => {
		pageIndex.value = 1
		getUserList()
	}
	
	const getUserList = () =>{
		loading.value = true
		requestYuqiUserList({
			dddepartid:dddepartid.value,
			pageIndex:pageIndex.value,
			pageSize:pageSize.value,
			startdate1:search.value.startdate1,
			startdate2:search.value.startdate2,
			tasktype:search.value.tasktype,
			sxlx:search.value.sxlx,
			idle:search.value.idle
		}).then((res:any)=>{
			if (res && res.status === 0) {
				// 未登录/登录超时等异常（后端异常时才返回 status:0）
				loading.value = false
				if (res.msg) ElMessage.warning(res.msg)
				return
			}
			// 成功响应：{pageIndex,pageSize,totalCount,DataMap:[...]}（无 status 字段）
			tableData.value = (res && (res.DataMap || res.datalist)) || []
			pages.value.totalCount = (res && res.totalCount) || tableData.value.length
			loading.value = false
		}).catch(()=>{
			loading.value = false
		})
	}
	
	//提交成功后
	const cancel = (val: any) => {
		addShow.value = false
		if(val){
			getUserList();
		}
	}
	
	const handleSizeChange = (val: number) =>{
		pageSize.value = val
		getUserList();
	}
	const handleCurrentChange = (val: number) =>{
		pageIndex.value = val
		getUserList();
	}
	const searchList = () =>{
		pageIndex.value = 1
		getUserList();
	}

	// ================== 点击统计数字查看任务列表 ==================
	// 列字段 -> 查询配置（lx: operator=执行/check=审核；zt: all/z1/y1/z3/y3 与后端口径一致）
	const clickColMap:{[key:string]:{lx:string,zt:string,label:string}} = {
		resutlAll:         {lx:'operator', zt:'all', label:'执行任务'},
		resutlStatus1:     {lx:'operator', zt:'z1',  label:'正常进行中任务'},
		resutlYqStatus1:   {lx:'operator', zt:'y1',  label:'逾期进行中任务'},
		result_yq_day:     {lx:'operator', zt:'y1',  label:'逾期进行中任务'},
		resutlCheckAll:    {lx:'check',    zt:'all', label:'审核任务'},
		resutlCheckStatus3:{lx:'check',    zt:'z3',  label:'正常待审核任务'},
		resutlYqCheckStatus3:{lx:'check',  zt:'y3',  label:'逾期待审核任务'},
		result_check_yq_day:{lx:'check',   zt:'y3',  label:'逾期待审核任务'}
	}
	const taskListShow = ref(false)
	const taskListTitle = ref('')
	const taskListData = ref<any[]>([])
	const taskLoading = ref(false)
	const taskPageIndex = ref(1)
	const taskPageSize = ref(10)
	const taskTotal = ref(0)
	const taskQuery = ref({ userid:'', lx:'', zt:'' })
	const details = (row:any, column:any) => {
		const cfg = clickColMap[column.property]
		if (!cfg || !row.id) return
		taskQuery.value = { userid: row.id, lx: cfg.lx, zt: cfg.zt }
		taskListTitle.value = `${row.name} - ${cfg.label}`
		taskPageIndex.value = 1
		taskListShow.value = true
		loadTaskList()
	}
	const loadTaskList = () => {
		taskLoading.value = true
		requestYuqiTaskUserList({
			userid: taskQuery.value.userid,
			lx: taskQuery.value.lx,
			zt: taskQuery.value.zt,
			startdate1: search.value.startdate1,
			startdate2: search.value.startdate2,
			tasktype: search.value.tasktype,
			sxlx: search.value.sxlx,
			pageIndex: taskPageIndex.value,
			pageSize: taskPageSize.value
		}).then((res:any)=>{
			taskListData.value = res.data || []
			taskTotal.value = res.totalCount || 0
			taskLoading.value = false
		}).catch(()=>{
			taskLoading.value = false
		})
	}
	const handleTaskSizeChange = (val: number) => {
		taskPageSize.value = val
		loadTaskList()
	}
	const handleTaskCurrentChange = (val: number) => {
		taskPageIndex.value = val
		loadTaskList()
	}

	// ================== 任务列表点击查看任务明细 ==================
	const taskDetailShow = ref(false)
	const taskDetailInner = ref(false)
	const taskDetailForm = ref<any>({})
	const openTaskDetails = (row:any) => {
		if (!row.cell) return
		taskDetailForm.value = row.cell
		taskDetailInner.value = false
		nextTick(()=>{
			taskDetailInner.value = true
		})
		taskDetailShow.value = true
	}
	const closeTaskDetails = () => {
		taskDetailShow.value = false
	}
	// 任务详情操作后刷新任务列表
	const taskListSx = () => {
		loadTaskList()
		taskDetailShow.value = false
	}

	// 状态显示（任务列表）
	const getStatus = computed(()=>{
		return function(status:number){
			let a = {
				0:"未启动",
				1:"进行中",
				2:"关闭",
				3:"待审核",
				4:"完成",
				5:"逾期进行中",
				6:"逾期待审核"
			}
			return a[status]
		}
	})
	const getType = computed(()=>{
		return function(status:number){
			let b = {
				1:"primary",
				2:"danger",
				3:"warning",
				4:"success",
				5:"danger",
				6:"warning"
			}
			return b[status]
		}
	})
	// 结合任务截至时间(enddate)判断逾期
	const getRowStatus = (cell:any):number => {
		const status = cell.status ? Number(cell.status) : 0
		if (status === 1 || status === 3) {
			const end = cell.enddate ? String(cell.enddate).substring(0, 10) : ''
			const today = new Date().toISOString().slice(0, 10)
			if (end && end < today) {
				return status === 1 ? 5 : 6
			}
		}
		return status
	}
	const DCsearchList = (val: number) =>{
		requestYuqiUserList({
			dddepartid:dddepartid.value,
			pageIndex:pageIndex.value,
			pageSize:pageSize.value,
			startdate1:search.value.startdate1,
			startdate2:search.value.startdate2,
			tasktype:search.value.tasktype,
			sxlx:search.value.sxlx,
			dc:1,
			dclx:val
		}).then((res:any)=>{
			window.open(res.datalist)
		})
	}
	
	const excelsx = () =>{
		excelShow.value = false
		nextTick(()=>{
			excelShow.value = true
		})
	}
	const excelcancel = () => {
		exceladdShow.value = false
		getUserList();
	}
	const exceladd = ()=>{
		excelsx();
		exceladdShow.value = true
	}

return (_ctx: any,_cache: any) => {
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_tree_select, {
              size: "small",
              modelValue: dddepartid.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dddepartid).value = $event)),
              data: deptTreeData.value,
              props: deptTreeProps,
              "render-after-expand": false,
              "check-strictly": "",
              filterable: "",
              clearable: "",
              placeholder: "请选择部门（含下级）",
              style: {"width":"220px"},
              onChange: onDeptChange
            }, null, 8, ["modelValue", "data"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_date_picker, {
              modelValue: search.value.startdate1,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.value.startdate1) = $event)),
              type: "date",
              placeholder: "开始时间",
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_date_picker, {
              modelValue: search.value.startdate2,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search.value.startdate2) = $event)),
              type: "date",
              placeholder: "截止时间",
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_el_select, {
              modelValue: search.value.tasktype,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((search.value.tasktype) = $event)),
              size: "small",
              placeholder: "请选择",
              style: {"width":"120px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }),
                _createVNode(_component_el_option, {
                  label: "通用任务",
                  value: "通用任务"
                }),
                _createVNode(_component_el_option, {
                  label: "计量任务",
                  value: "计量任务"
                }),
                _createVNode(_component_el_option, {
                  label: "定额任务",
                  value: "定额任务"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_el_select, {
              modelValue: search.value.sxlx,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((search.value.sxlx) = $event)),
              size: "small",
              placeholder: "请选择",
              style: {"width":"120px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sxlxLists.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.value,
                    value: item.value,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_el_select, {
              modelValue: search.value.idle,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((search.value.idle) = $event)),
              size: "small",
              placeholder: "请选择",
              style: {"width":"120px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }),
                _createVNode(_component_el_option, {
                  label: "是",
                  value: "1"
                }),
                _createVNode(_component_el_option, {
                  label: "否",
                  value: "0"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (searchList())),
            size: "small",
            icon: _unref(Search),
            type: "primary",
            plain: ""
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }, 8, ["icon"]),
          _createVNode(_component_el_button, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (DCsearchList(0))),
            size: "small",
            icon: _unref(Search),
            type: "primary",
            plain: ""
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }, 8, ["icon"]),
          _createVNode(_component_el_button, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (DCsearchList(1))),
            size: "small",
            icon: _unref(Search),
            type: "primary",
            plain: ""
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }, 8, ["icon"])
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      onCellClick: details,
      "empty-text": "暂无数据",
      data: tableData.value,
      "header-cell-style": {color:'#000',backgroundColor:'#fafbfd',whiteSpace:'normal',lineHeight:'18px',textAlign:'center',padding:'6px 0'},
      "cell-style": {textAlign:'center'}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "80",
          label: "序号",
          align: "center",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "姓名",
          width: "80",
          fixed: "",
          sortable: ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "resutlAll",
          label: "执行任务总数",
          sortable: ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_21, _toDisplayString(scope.row.resutlAll), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "resutlStatus1",
          label: "正常进行中",
          sortable: ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_22, _toDisplayString(scope.row.resutlStatus1), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "resutlYqStatus1",
          label: "逾期进行中",
          sortable: ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_23, _toDisplayString(scope.row.resutlYqStatus1), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "result_yq_day",
          label: "执行逾期总天数",
          sortable: ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_24, _toDisplayString(scope.row.result_yq_day), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "resutlCheckAll",
          label: "审核任务总数",
          sortable: ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_25, _toDisplayString(scope.row.resutlCheckAll), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "resutlCheckStatus3",
          label: "正常待审核",
          sortable: ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_26, _toDisplayString(scope.row.resutlCheckStatus3), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "resutlYqCheckStatus3",
          label: "逾期待审核",
          sortable: ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_27, _toDisplayString(scope.row.resutlYqCheckStatus3), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "result_check_yq_day",
          label: "审核逾期总天数",
          sortable: ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_28, _toDisplayString(scope.row.result_check_yq_day), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createVNode(_component_el_dialog, {
      title: "添加",
      modelValue: addShow.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((addShow).value = $event)),
      "show-close": false,
      "close-on-click-modal": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (addShow.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Close))
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (userShow.value)
          ? (_openBlock(), _createBlock(AddUser, {
              key: 0,
              onCancel: cancel,
              uuid: uuid.value
            }, null, 8, ["uuid"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "Excel导入",
      modelValue: exceladdShow.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((exceladdShow).value = $event)),
      "show-close": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (exceladdShow.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Close))
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (excelShow.value)
          ? (_openBlock(), _createBlock(_unref(Excel), {
              key: 0,
              onCancel: _cache[12] || (_cache[12] = ($event: any) => (excelcancel())),
              id: "用户导入"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      top: "5vh",
      modelValue: taskListShow.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((taskListShow).value = $event)),
      "show-close": false,
      fullscreen: ""
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", null, _toDisplayString(taskListTitle.value), 1),
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (taskListShow.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Close))
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          onCellClick: openTaskDetails,
          "empty-text": "暂无数据",
          data: taskListData.value,
          "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "index",
              width: "60",
              label: "序号",
              align: "center",
              fixed: "left"
            }),
            _createVNode(_component_el_table_column, {
              prop: "cell.projectname",
              label: "项目名称",
              width: "150",
              fixed: "left",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "cell.type1",
              label: "事项类型",
              width: "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "cell.tasktitle",
              label: "任务标题",
              width: "180",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "cell.operatorname",
              label: "执行人",
              width: "90",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "cell.checkname",
              label: "审核人",
              width: "90",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "cell.startdate",
              label: "开始时间",
              width: "110",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "cell.enddate",
              label: "要求完成时间",
              width: "110",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "状态",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_tag, {
                  type: _unref(getType)(getRowStatus(scope.row.cell))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getStatus)(getRowStatus(scope.row.cell))), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, taskLoading.value]
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_el_pagination, {
            onSizeChange: handleTaskSizeChange,
            onCurrentChange: handleTaskCurrentChange,
            "current-page": taskPageIndex.value,
            "page-sizes": [10, 20, 50, 100],
            "page-size": taskPageSize.value,
            layout: "total, sizes, prev, pager, next, jumper",
            total: taskTotal.value
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: taskDetailShow.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((taskDetailShow).value = $event)),
      "show-close": false,
      fullscreen: ""
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (closeTaskDetails()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Close))
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (taskDetailInner.value)
          ? (_openBlock(), _createBlock(TaskDetails, {
              key: 0,
              form: taskDetailForm.value,
              onTaskListsx: taskListSx
            }, null, 8, ["form"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})